import React from 'react';

const VideoIframe = ({ title, src, width, height }) => {
	return (
		<div className="c-video-iframe" style={{ paddingTop: `${(height / width) * 100}%` }}>
			<iframe
				title={title}
				width={width}
				height={height}
				src={src}
				frameBorder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			></iframe>
		</div>
	);
};

export default VideoIframe;
